<template>
  <div class="wrapper" @keyup='ClickHandler' @mousemove='ClickHandler' @click='ClickHandler'>

    <div class="notifications"><span mode="in-out"></span></div>

    <loading :active.sync="isLoading" 
        :can-cancel="true" 
        :on-cancel="onCancel"
        :is-full-page="fullPage"></loading>
    <div class="sidebar" v-if='this.$session.exists()'>
      <keep-alive>
        <SideNavBar/>
      </keep-alive>
    </div>
    <div class="main-panel">
      <TopNavBar v-if='this.$session.exists()'/>
      <b-modal hide-footer
      id="modalPrevent2"
      ref="myModalRef5"
      title="Alert... !!!"
      ><div class="d-block text-center">
          <h3>Your stack has been freed</h3>
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="$refs.myModalRef5.hide()">Close Me</b-button>
      </b-modal>
      
      <section class="app-main-content">
        <router-view></router-view>
        <beautiful-chat
          :participants="participants"
          :titleImageUrl="titleImageUrl"
          :onMessageWasSent="onMessageWasSent"
          :messageList="getmessagelist"
          :newMessagesCount="getnewMessage"
          :isOpen="isChatOpen"
          :close="closeChat"
          :open="openChat"
          :showEmoji="true"
          :showFile="true"
          :showTypingIndicator="showTypingIndicator"
          :colors="colors"
          :alwaysScrollToBottom="alwaysScrollToBottom"
          :messageStyling="messageStyling" >
      </beautiful-chat>
      </section>
    </div>
  </div>
</template>

<script>
  import http from "../http-common"
  import SockJS from "sockjs-client"
  import Stomp from "webstomp-client"
  import TopNavBar from './TopNavBar.vue'
  import SideNavBar from './SideNavBar.vue'
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
  import down from 'msgdown'
  import Loading from 'vue-loading-overlay'

  export default {
    name: 'LoggedInView',
    data() {
      return {
        isLoading: false,
        fullPage: true,
        checksession:'',
        stackname:'',
        from_input:'',
        send_message: null,
        connected: false,
        stompvalue:'',
        participants: [{ id: "", name: "" }],
        titleImageUrl: 'https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png',
        isChatOpen: false,
        showTypingIndicator: '',
        colors: {
          header: {
            bg: '#4e8cff',
            text: '#ffffff'
          },
          launcher: {
            bg: '#4e8cff'
          },
          messageList: {
            bg: '#ffffff'
          },
          sentMessage: {
            bg: '#4e8cff',
            text: '#ffffff'
          },
          receivedMessage: {
            bg: '#eaeaea',
            text: '#222222'
          },
          userInput: {
            bg: '#f4f7f9',
            text: '#565867'
          }
        }, 
        alwaysScrollToBottom: true ,
        refresh:false,
        messageStyling: true,
        idle_timeout : 6000
      };
    },
    components: {
      TopNavBar,
      SideNavBar,
      Loading
    },
    methods: {
      ...mapActions([
       'commitactivetab_actions',
       'send_actions',
       'connect_actions',
       'subscribe_actions',
       'tickleConnection_actions',
       'commitmessagelist',
       'commitnewMessage',
       'commitseenmessage',
       'commitidleSecondsCounter',
       'commitsessioncheck',
       'disconnect_actions',
       'commitstackname',
       'commitisLoading'
      ]),
      onCancel() {
              console.log('User cancelled the loader.')
            },
      send_actions_click(){
        var msg={
          message:'hai',
          url:'/app/test'
        }
        this.send_actions(msg)
      },
      async getallchats() {
           await http
           .get("/getallchat")
           .then(response => {
                for(var data in response.data){

                  var auth="me"
                  if(response.data[data].employee != this.$session.get("username")){
                      auth=response.data[data].employee 
                  }
                  var msg = '*'+response.data[data].message+'*'
                  if(auth!="me"){
                      if(response.data[data].message.length<22){
                              msg ='^'+response.data[data].employee+'^'+Array(2).join(" ")+'^'+response.data[data].date+'^'+"\n"+"*"+response.data[data].message+"*"+" \n"+'¡'+response.data[data].time+'¡'
                          }else{
                            msg ='^'+response.data[data].employee+'^'+Array(2).join(" ")+'^'+response.data[data].date+'^'+"\n"+"*"+response.data[data].message+"*"+" \n"+'¡'+response.data[data].time+'¡'
                          }
                  }
                  var obj={ type: 'text', author: auth , data: { text: msg } }
                  this.commitmessagelist(obj)
                }
                
              })
           .catch(e => {
             console.log(e);
           });
         },
      getmsgseencount(){
        http
           .post("/getmsgseencount",this.$session.get("username"))
           .then(response => {
               this.commitseenmessage(parseInt(response.data, 10))
              })
           .catch(e => {
             console.log(e);
           });
      },
      getallactiveuser() {
           http
           .get("/getallactiveuser")
           .then(response => {
            var listvar=[]
                for(var data in response.data){  
                  if(response.data[data] != this.$session.get("username")){
                    var obj={
                              id: response.data[data],
                              name: response.data[data],
                            }
                    this.participants = [ ...this.participants, obj ]
                  
                    }
                }
              })
           .catch(e => {
             console.log(e);
           });
         },
      sendMessage (user,text) {
          if (text.length > 0) {
            if(this.isChatOpen){
            this.commitnewMessage(this.getnewMessage )
            }else{
              this.commitnewMessage(this.getnewMessage +1)
            }
            this.onMessageWasSent({ author: user, type: 'text', data: { text: msg } })
          }
        },
      onMessageWasSent (message) {

          var msg = '*'+message.data.text+'*'
          if(message.author!="me"){
              msg = '*'+message.author+'*'+":"+message.data.text+''+"   "
          }
          
          var obj={ type: 'text', author: message.author , data: { text: msg }}
          var d = new Date()

          var data={text:message.data.text , time: d.toLocaleTimeString(), date:d.toLocaleDateString()}
          if(this.from_input==""){
            this.send(this.$session.get("username"),data)
          }
          this.commitmessagelist(obj)
          this.from_input=""
        },
      openChat () {
          this.isChatOpen = true
          this.commitnewMessage(0)
          this.commitseenmessage(this.getmessagelist.length)
        },
      closeChat () {
          this.isChatOpen = false
        },
      ClickHandler(event){
          this.commitidleSecondsCounter(0)
        },
      CheckIdleTime(){
        if(this.$session.exists()){
              this.commitidleSecondsCounter(this.getidleSecondsCounter+1)
              if (this.getidleSecondsCounter >= this.idle_timeout) {
                alert("Time expired!");
                this.commitidleSecondsCounter(0)
                this.closesocket()
              }
          }
        },
      closesocket: function() {
        var msg={
                message:"logout",
                url:"/app/chatlist"
              }
              this.send_actions(msg)
              this.disconnect_actions()
              this.$router.push({ name: 'logout'})
        },
      send(emp,msge) {
          const message = {employee: emp ,message: msge.text,time: msge.time, date: msge.date}
          var msg={
            message:message,
            url:"/app/chathello"
          }
          this.send_actions(msg)
          this.setseenmessagefun()
        },
      setsession(){
          if(this.$session.exists()!=this.getsessioncheck){
            this.commitsessioncheck(this.$session.exists())
          }
          var msg={message:"logedin",
                      url:"/app/test"}
          //this.send_actions(msg) 
          
        },
      setseenmessagefun(){
        var lst=[this.$session.get("username"),this.getmessagelist.length-this.getnewMessage]
        http
           .post("/setmsgseencount",lst)
           .then(response => {
              this.commitseenmessage(this.getmessagelist.length-this.getnewMessage)
              })
           .catch(e => {
             console.log(e);
           });
      },
      retrieveUsed(name) {
        http
        .post("/used",name)
        .then(response => {
          if(response.data[0]!=null){
              this.$session.set("stackname",response.data[0]['stackname'])
              this.commitstackname(response.data[0]['stackname'])
          }else{
              this.$session.set("stackname","")
            }
        })  
        .catch(e => {
          console.log(e)
        });
      }

    },
    computed: {
        ...mapGetters([
          'getreceived_messages_store',
          'getmessagelist',
          'getnewMessage',
          'getseenmessage',
          'getidleSecondsCounter',
          'getsessioncheck',
          'getstackname',
          'getisLoading',
          'getactivetab',
          'getconnected_store'
        ])
      },
    watch: {
      getconnected_store:function(val){
        if(val==true){
          this.subscribe_actions("/topic/chats")
          this.subscribe_actions("/topic/employeechatlist")
          this.subscribe_actions("/topic/greetings")
          this.subscribe_actions("/topic/test")
          var myTimerPromise = new Promise((resolve, reject) => {
              setTimeout(() => {
                  var msg={
                      message:"login",
                      url:"/app/chatlist"
                    }
                  this.send_actions(msg) 
                  this.commitnewMessage(this.getmessagelist.length-this.getseenmessage)
                  this.commitisLoading(false)
                  
                  resolve();
              }, 50); 
          });
        }
      },
      getactivetab: function(val){
        console.log("getactivetab",val)
      },
      getisLoading: function(val){
          this.isLoading=val
      },
      getstackname: function(val){

      },
      getsessioncheck: function(val){
          if(val==false ){
                this.commitidleSecondsCounter(0)
                this.closesocket()
          }
      },
      getnewMessage:function(val){
          this.setseenmessagefun()

      },
      checksession:function(val){
          if(val!=true){
            this.$router.push({ name: 'login'})  
          }
        },
      getreceived_messages_store:function (val){

          if(val.content_type=="chats_message"){
            if(this.isChatOpen){
              this.commitnewMessage(this.getnewMessage )
            }else{
              this.commitnewMessage(this.getnewMessage +1)
            }
            if(val.data.author!=this.$session.get("username")){
              this.commitmessagelist(val.data)
            }
          }
          if(val.content_type=="chats_list_change"){
            this.participants=[
                          {
                              id: "",
                              name: ""
                          }               
                          ]
            var myTimerPromise = new Promise((resolve, reject) => {
                    setTimeout(() => {
                        this.getallactiveuser()
                        resolve();
                    }, 1000); 
            });
            

          }
          if(val.content_type=="stack_changes"){
            var checkval="Free Stack:"+this.getstackname
          if(val.data.content==checkval){
              this.$refs.myModalRef5.show();
              this.$session.set("stackname","")
          }
          }
        },
      refresh:function (val){
          if(val==true){
            this.getallactiveuser()
          }
          this.refresh=false
        }
      
        },
        mounted(){
        },
    async created () {
        console.log("getactivetab",this.getactivetab)
        console.log("getconnected_store",this.getconnected_store)
        this.commitisLoading(true)
        window.addEventListener('beforeunload', () => {
            //I CAN ACCESS TO this VARIABLE
            if(!this.$session.exists()){         
              this.commitidleSecondsCounter(0)
              this.closesocket()
            }
        }, false)
        await this.connect_actions()
        await this.getallactiveuser()
        await this.getallchats()
        await this.getmsgseencount()
        await this.retrieveUsed(this.$session.get("username"))
        this.stackname=this.$session.get("stackname")
        var myTimerPromise = new Promise((resolve, reject) => {
              setInterval(() => {
                if(this.$session.exists()){
                  this.CheckIdleTime()
                }
                  resolve();
              }, 1000); 
        });
        this.interval = setInterval(this.setsession, 2000)
      }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500');
@import '~bootstrap/dist/css/bootstrap.css';
@import '../styles/custom.css';
.app-main-content{
  padding-top: 20px;
}
.main-panel{
  position:relative;
  background-color:#f1f1f1;
  width:calc(100% - 260px);
  float:right;
  z-index:1;
}
.table{
  text-align:inherit;
}
.wrapper{
  background-color:#f1f1f1;
  position:absolute;
  top:0%;
  left:0%;
  right:0%;
  bottom:0%;
}
@media only screen and (max-width: 1125px) {
  .sidebar{
    display:none;
  }
  .main-panel{
    width:100%;
  }
}
@media only screen and (max-width: 1325px) {
  .main-panel{
    width:calc(100% - 80px);
  }
}


.chromeframe {
    margin: 0.2em 0;
    background: #ccc;
    color: #000;
    padding: 0.2em 0;
}
</style>
